import Head from "next/head";
import CarDetails from "../../../../../components/car-details/car-details-form";
import Footer from "../../../../../components/layout/footer";
import Header from "../../../../../components/layout/header";
import { useRouter } from "next/router";
import { fetchGetAd, fetchGetCompanyGeneralData } from "../../../../../../services/api";
import { capitalize } from "../../../../../../utils/utils";

export default function VehicleDetailsPage({ companyGeneralData, ad }) {
    const router = useRouter();
    companyGeneralData = JSON.parse(companyGeneralData);

    return (
        <>
            <Head>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="description" content={`Confira os detalhes deste veículo na MSX Motors em Jacareí. Carro usado ou seminovo com procedência, garantia, financiamento e atendimento pelo WhatsApp.`} />
                <meta name="keywords" content={`veículo seminovo Jacareí, carro usado Jacareí, carro com garantia, financiamento de veículo, comprar carro Jacareí, MSX Motors`} />
                <meta name="author" content="https://bndv.com.br" />
                <title>{`Veículo Usado ou Seminovo em Jacareí | MSX Motors`}</title>
            </Head>

            <div className="main-wrapper">
                <Header company={companyGeneralData.company} />
                <CarDetails ad={ad} company={companyGeneralData.company} />
                <Footer company={companyGeneralData.company} />
            </div>
        </>
    )
}

export async function getServerSideProps({ query }) {
    try {
        const companyGeneralData = await fetchGetCompanyGeneralData();
        
        const ad = await fetchGetAd({ idAd: query.id });
        if (!ad || !ad.id) {
            return {
                notFound: true,
            };
        }
        
        return { 
            props: { 
                ad,
                companyGeneralData: JSON.stringify(companyGeneralData)
            } 
        };
    } catch (error) {
        console.error("Erro ao buscar dados:", error);
        return {
            notFound: true,
        };
    }
}